import * as React from 'react';
// @ts-expect-error
import {Controller} from 'react-hook-form';
// @ts-expect-error
import type {Control, Watch} from 'react-hook-form';

import {Button} from 'shells/button/button';
import {FileUploadButton} from 'shells/button/file-upload-button/file-upload-button';
import {FormField} from 'shells/form/form-field';
import {RangeInput} from 'shells/range-input/range-input';
import {TextField} from 'shells/textfield/textfield';

import {handleFileUpload} from '../../../../helpers';
import type {Field} from '../../../../types';

import {FormAlignmentSelector} from '../form-alignment-selector.js/form-alignment-selector';

import styles from '../design-form.module.css';

type Props = {
    control: Control;
    name: string;
    watch: Watch;
    field: Field;
};

export function ImageDesignForm(props: Props) {
    const id = props.watch(`${props.name}.id`);
    const imageUrl = props.watch(`${props.name}.imageUrl`);

    return (
        <>
            <FormField innerId='image' label='Image'>
                <Controller
                    name={`${props.name}.imageUrl`}
                    control={props.control}
                    // @ts-expect-error
                    render={({field}) => {
                        const onClickHandler = () => {
                            handleFileUpload(field, id);
                        };

                        return (
                            <div className={styles['image-field-image-container']}>
                                {field.value ? (
                                    <>
                                        <img src={field.value} className={styles['image-styles']} />
                                        <div
                                            onClick={onClickHandler}
                                            className={styles['image-field-overlay']}
                                        >
                                            <Button
                                                variant='primary'
                                                onClick={onClickHandler}
                                                size='big'
                                            >
                                                Change image
                                            </Button>
                                        </div>
                                    </>
                                ) : (
                                    <div className='flex justify-center align-center'>
                                        <FileUploadButton
                                            id='fileUpload'
                                            name='Select an image'
                                            onClick={onClickHandler}
                                        />
                                    </div>
                                )}
                            </div>
                        );
                    }}
                />
            </FormField>
            {/* @ts-expect-error */}
            {props.field.imageUrl || imageUrl ? (
                <>
                    <FormField innerId='label' label='Alt text'>
                        <Controller
                            name={`${props.name}.label`}
                            control={props.control}
                            // @ts-expect-error
                            render={({field}) => (
                                <TextField
                                    value={field.value}
                                    onChange={(newLabel) => {
                                        field.onChange(newLabel);

                                        return new Promise((resolve) => {
                                            // @ts-expect-error
                                            resolve();
                                        });
                                    }}
                                    selectOnFocus={true}
                                />
                            )}
                        />
                    </FormField>
                    <FormField innerId='width' label='Width'>
                        <Controller
                            name={`${props.name}.width`}
                            control={props.control}
                            // @ts-expect-error
                            render={({field}) => {
                                return (
                                    <RangeInput
                                        value={field.value}
                                        onChange={(newValue) => {
                                            field.onChange(newValue);
                                        }}
                                        min={30}
                                        max={100}
                                    />
                                );
                            }}
                        />
                    </FormField>
                    <FormField innerId='justifyContent' label='Image position' noMargin={true}>
                        <Controller
                            name={`${props.name}.justifyContent`}
                            control={props.control}
                            // @ts-expect-error
                            render={({field}) => (
                                <FormAlignmentSelector
                                    currentPosition={field.value}
                                    onSetCurrentPosition={field.onChange}
                                    shouldUseFlexBoxValues={true}
                                />
                            )}
                        />
                    </FormField>
                </>
            ) : null}
        </>
    );
}
